<template>
  <div class="archive-modal">
    <div class="header">
      <MessageBox level="warning">
        Are you sure you want to archive this order?
      </MessageBox>
    </div>
    <div class="message-container" v-if="showMessage">
      <div class="message-input">
        <Input @updateModel="emailMessage = $event" :model="emailMessage" :isEdit="true" :inputData="{
          type: 'textarea',
          title: 'Order Cancellation Message (optional)',
          placeholder: 'Entering a message will send a confirmation email.\n\nAlternatively, leave blank to not send a message.',
          rows: 3
        }" />
      </div>
    </div>
    <div class="footer">
      <BaseBtn iconGroup="fas" iconName="times" :colorType="3" label="Cancel" @click="onCancel()" />
      <BaseBtn iconGroup="fas" iconName="trash" :colorType="1" label="Archive Order" @click="archive()"
        :disabled="archiving" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BaseBtn from "@/components/Base/Button/Button.vue";
import Input from "@/components/Input/Input.vue";
import MessageBox from "@/components/MessageBox/MessageBox.vue";

export default {
  components: {
    BaseBtn,
    Input,
    MessageBox
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    archiveLocation: {
      type: String,
      default: 'pos'
    }
  },
  data() {
    return {
      archiving: false,
      emailMessage: ''
    }
  },
  computed: {
    showMessage() {
      return this.order.customer?.email;
    }
  },
  methods: {
    ...mapActions({
      setMessage: "setMessage",
      archiveOrder: "orderModule/archiveOrder",
      archiveOpenOrderAsync: "orderModule/archiveOpenOrderAsync",
    }),
    onCancel() {
      this.$emit('onClose')
    },
    async archive() {
      this.archiving = true;

      if(this.archiveLocation === 'pos')
      {
        this.archiveOrder({message: this.emailMessage, positiveCallback: () => {
        this.setMessage({
            text: "Order archived",
            type: "success",
          });
          this.$emit('onClose')
        }});
      } else {
        try {
          await this.archiveOpenOrderAsync({order: this.order, message: this.emailMessage});
          this.setMessage({
            text: "Order archived",
            type: "success",
          });
          this.$emit('onClose')
        } catch(error) {
          this.archiving = false;
          this.setMessage({
            text: error.message || "Error archiving order",
            type: "error",
          });
        }
      }
    }
  },
}

</script>

<style scoped lang="scss">
.archive-modal {
  width: 40rem;
}

.footer {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.bar {
  width: 100%;
}

.body {
  display: flex;
  align-items: center;
  padding: 1rem;
  width: 100%;
  max-width: 300px;
  margin: auto;
}

.header {
  padding: 1rem;
}

.center {
  padding: 1rem;
  text-align: center;
  font-size: $text-size-2;
}

.message-container {
  padding: 0 10px;
}
</style>
